import { Button, CircularProgress } from '@mui/material';
import React, { FC, MouseEvent } from 'react';
import { CustomTooltip } from '../../CustomTooltip';
import { ButtonClassNames } from '../../../../models/Common';
import { useDebounce } from '../../../../hooks/useDebounce';

interface BasicButtonProps {
  label: string | JSX.Element;
  handleClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className: ButtonClassNames;
  isBold?: boolean;
  tooltipText?: string | boolean;
  isDisabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
  noWrap?: boolean;
}

const defaultProps = {
  type: undefined,
  handleClick: undefined,
  isBold: false,
  tooltipText: false,
  isDisabled: false,
  isLoading: false,
  noWrap: false,
};

export const CustomMUIButton: FC<BasicButtonProps> = ({
  label,
  handleClick,
  className,
  isBold,
  tooltipText,
  isDisabled,
  type,
  isLoading,
  noWrap,
}) => {
  const handleDebouncedClick = useDebounce((event: MouseEvent<HTMLButtonElement>) => {
    if (handleClick) handleClick(event);
  }, 200);

  return tooltipText ? (
    <CustomTooltip
      child={
        <div>
          <Button
            className={`button button__basic__${className} ${isBold ? `button button__basic__${className}_bold` : ''} ${
              isDisabled ? `button button__basic__${className}_disabled` : ''
            } ${noWrap ? 'no_wrap' : ''}`}
            type={type}
            variant="contained"
            onClick={handleDebouncedClick}
            disabled={isDisabled}
          >
            {label}
          </Button>
        </div>
      }
      tooltipText={tooltipText === true ? '' : tooltipText}
    />
  ) : (
    <Button
      className={`button button__basic__${className} ${isBold ? `button button__basic__${className}_bold` : ''} ${
        isDisabled || isLoading ? `button button__basic__${className}_disabled` : ''
      } ${isLoading ? `button button__basic__${className}_loading` : ''} ${noWrap ? 'no_wrap' : ''}`}
      variant="contained"
      type={type}
      onClick={handleDebouncedClick}
      disabled={isDisabled || isLoading}
    >
      {label} {isLoading && <CircularProgress size={24} />}
    </Button>
  );
};

CustomMUIButton.defaultProps = defaultProps;
